/*
 * Copyright (c) 2026 Dobler Data Solutions, LLC
 * Fabric Control Plane - Operations Dashboard Layout
 * Feature #117: Operational Dashboards
 * Constitution: v1.12.0
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Operations dashboard layout wrapper
 * Provides consistent layout for all operational dashboards (FR-003).
 * Breadcrumb is rendered by the parent AppLayout — not duplicated here.
 */
export const OperationsLayout: React.FC = () => {
  return (
    <div className="operations-layout p-4 sm:p-6 lg:p-8">
      <Outlet />
    </div>
  );
};

export default OperationsLayout;
